import ResultHeader from "../../components/table/ResultHeader";
import ResultRow from "../../components/table/ResultRow";
import ResultHeaderCell from "../../components/table/ResultHeaderCell";
import ResultBody from "../../components/table/ResultBody";
import ResultTable from "../../components/table/ResultTable";
import ResultBodyCell from "../../components/table/ResultBodyCell";
import {Checkbox} from "antd";
import {Layers} from "../map-plugins/LayerSelectLeaflet";

export default function ModelLayersSettings({onValuesChange, values, defValues}) {
    const selectedLayers = values?.model_layers || defValues?.model_layers || [...Layers]

    const isChecked = (layer) => {
        return selectedLayers.includes(layer)
    }

    const onChange = (layer, checked) => {
        let newLayers = [...selectedLayers]
        if(checked) {
            if(!newLayers.includes(layer)) {
                newLayers.push(layer)
            }
        } else {
            newLayers = newLayers.filter(x => x !== layer)
        }
        onValuesChange('model_layers', newLayers)
    }

    return (
        <>
            <ResultTable>
                <ResultHeader>
                    <ResultRow>
                        <ResultHeaderCell style={{textAlign: 'left', width: 250}}>Layer Name</ResultHeaderCell>
                        <ResultHeaderCell style={{textAlign: 'center', width: 100}}>Show by Default</ResultHeaderCell>
                        <ResultHeaderCell style={{textAlign: 'center', width: 100}}>System Default</ResultHeaderCell>
                    </ResultRow>
                </ResultHeader>
                <ResultBody>
                    {
                        Layers.map((layer, index) => (
                            <ResultRow key={index}>
                                <ResultBodyCell style={{textAlign: 'left'}}>{layer}</ResultBodyCell>
                                <ResultBodyCell style={{textAlign: 'center'}}>
                                    <Checkbox
                                        checked={isChecked(layer)}
                                        onChange={(e) => onChange(layer, e.target.checked)}
                                    />
                                </ResultBodyCell>
                                <ResultBodyCell style={{textAlign: 'center'}}>
                                    <Checkbox
                                        checked={defValues?.model_layers?.includes(layer) ?? true}
                                        disabled={true}
                                    />
                                </ResultBodyCell>
                            </ResultRow>
                        ))
                    }
                </ResultBody>
            </ResultTable>
        </>
    )
}
